export enum GEN_FAVORITES_DIALOGS {
    ADD_TO_FAVORITES = "ADD_TO_FAVORITES",
    CREATE_OR_EDIT_FAVORITES_LIST = "CREATE_OR_EDIT_FAVORITES_LIST",
    FAVORITES_CONFIRM_ACTION = "FAVORITES_CONFIRM_ACTION",
    FAVORITE_PRODUCTS_ADDED_TO_CART = "FAVORITE_PRODUCTS_ADDED_TO_CART",
}